import React from 'react';
import { Select, Button } from 'antd';
import { CheckCheck } from 'lucide-react';
import { FilterBar, FilterField, StatusTag } from '../../common';
import { getTypeConfig, getSeverityConfig } from './notificationConfig';

const TypeOption = ({ type, children }) => (
    <span className="flex items-center gap-2">
        <span className={`w-2 h-2 rounded-full ${type ? getTypeConfig(type).dot : 'bg-surface-400'}`} />
        {children}
    </span>
);

const SeverityOption = ({ severity, children }) => <StatusTag tone={getSeverityConfig(severity).tone}>{children}</StatusTag>;

export default function NotificationFilters({
    filterType,
    filterSeverity,
    filterRead,
    setFilterType,
    setFilterSeverity,
    setFilterRead,
    markMultipleAsRead,
    notifications
}) {
    const unreadNotifications = notifications.filter((n) => !n.read);

    const handleMarkAllAsRead = () => {
        const unreadIds = unreadNotifications.map((n) => n._id);
        if (unreadIds.length > 0) {
            markMultipleAsRead(unreadIds);
        }
    };

    return (
        <FilterBar
            className="!mb-0"
            actions={
                // Mark all read — only when there is something unread
                unreadNotifications.length > 0 && (
                    <Button type="primary" icon={<CheckCheck />} onClick={handleMarkAllAsRead}>
                        Marcar leídas
                        <span className="ml-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-md bg-white/20 px-1.5 text-xs font-semibold tabular-nums">
                            {unreadNotifications.length}
                        </span>
                    </Button>
                )
            }>
            <FilterField label="Tipo" width={200}>
                <Select value={filterType} onChange={setFilterType} className="w-full">
                    <Select.Option value="all">
                        <TypeOption>Todas</TypeOption>
                    </Select.Option>
                    <Select.Option value="quiebre_stock">
                        <TypeOption type="quiebre_stock">Quiebre de Stock</TypeOption>
                    </Select.Option>
                    <Select.Option value="low_inventory">
                        <TypeOption type="low_inventory">Inventario Bajo</TypeOption>
                    </Select.Option>
                    <Select.Option value="system">
                        <TypeOption type="system">Sistema</TypeOption>
                    </Select.Option>
                </Select>
            </FilterField>

            <FilterField label="Severidad" width={160}>
                <Select value={filterSeverity} onChange={setFilterSeverity} className="w-full">
                    <Select.Option value="all">Todas</Select.Option>
                    <Select.Option value="low">
                        <SeverityOption severity="low">Baja</SeverityOption>
                    </Select.Option>
                    <Select.Option value="medium">
                        <SeverityOption severity="medium">Media</SeverityOption>
                    </Select.Option>
                    <Select.Option value="high">
                        <SeverityOption severity="high">Alta</SeverityOption>
                    </Select.Option>
                    <Select.Option value="critical">
                        <SeverityOption severity="critical">Crítica</SeverityOption>
                    </Select.Option>
                </Select>
            </FilterField>

            <FilterField label="Estado" width={160}>
                <Select value={filterRead} onChange={setFilterRead} className="w-full">
                    <Select.Option value="all">Todas</Select.Option>
                    <Select.Option value="unread">Sin leer</Select.Option>
                    <Select.Option value="read">Leídas</Select.Option>
                </Select>
            </FilterField>
        </FilterBar>
    );
}
